import { render, staticRenderFns } from "./AmazonProductos.vue?vue&type=template&id=0d779a8a&scoped=true&"
import script from "./AmazonProductos.vue?vue&type=script&lang=js&"
export * from "./AmazonProductos.vue?vue&type=script&lang=js&"
import style0 from "./AmazonProductos.vue?vue&type=style&index=0&id=0d779a8a&prod&lang=scss&scoped=true&"
import style1 from "./AmazonProductos.vue?vue&type=style&index=1&id=0d779a8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d779a8a",
  null
  
)

export default component.exports